<template>
  <div class="bg-white h-full w-full">
    <GradientHeader
      :logo="logo"
      :colour="colours.primary"
      fullHeight
    >
      <OffsetColorBox
        :colour="colours.accentPrimary"
        :gray="colours.primaryIsWhite"
        class="w-160 max-w-full mx-auto px-4"
        smallHeading
        boxInnerClass="md:px-10"
      >
        <template slot="heading">
          {{ $t('otp.codeRequired') }}
        </template>

        <IconCircular
          slot="icon"
          class="bg-warn !w-10 !h-10 translate-y-1"
          :style="`background: ${colours.accentPrimary}`"
        >
          <LockIcon
            class="w-3/5"
            :style="`color: ${colours.accentSecondary}`"
          />
        </IconCircular>

        <template v-if="!codeSent">
          <p class="text-body px-4 md:px-8 mb-2">
            {{ $t('otp.sendCodeMessage', { phone: mobileLastFour }) }}
          </p>
          <p class="text-14 text-midGrey m-0">
            {{ $t('otp.sendCodeAdvice') }}
          </p>

          <div class="flex flex-col">
            <BaseButton
              class="!font-medium !text-body mt-6 mx-auto"
              :loading="sendingCode"
              @click.native="handleSendCode"
            >
              {{ $t('otp.send') }}
            </BaseButton>

            <BaseButton
              variant="invisible"
              class="!font-medium !text-body !text-blue !no-underline mt-2"
              @click.native="codeSent = true"
            >
              {{ $t('otp.haveCode') }}
            </BaseButton>
          </div>
        </template>

        <template v-else>
          <p class="text-body px-4 md:px-8">
            {{ $t('otp.codeRequiredMessage', { phone: mobileLastFour }) }}
          </p>

          <OtpEntry
            :otpStatus="otpStatus"
            :verifyOtp="verifyOtp"
          />

          <BaseButton
            v-show="showResendCode"
            variant="invisible"
            class="!font-medium !text-body !text-blue mt-2 !no-underline"
            @click.native="codeSent = false"
          >
            {{ $t('otp.resendCode') }}
          </BaseButton>
        </template>
      </OffsetColorBox>
    </GradientHeader>
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue'

import GradientHeader from '@/components/library/GradientHeader.vue'
import OffsetColorBox from '@/components/library/OffsetColorBox.vue'
import IconCircular from '@/components/icons/IconCircular.vue'
import LockIcon from '@/components/icons/LockIcon.vue'
import OtpEntry from '@/components/library/OtpEntry.vue'
import BaseButton from '@/components/library/buttons/BaseButton.vue'

const props = defineProps({
  branding: Object,
  otpStatus: Object,
  verifyOtp: Function,
  sendCode: Function,
  mobileLastFour: String
})

const sendingCode = ref(false)
const codeSent = ref(false)
const showResendCode = ref(false)

const colours = computed(() => props.branding ? props.branding.colours : { accentSecondary: '#ffffff' })
const logo = computed(() => props.branding && props.branding.logo)

const handleSendCode = async () => {
  sendingCode.value = true
  await props.sendCode()
  codeSent.value = true
  sendingCode.value = false

  showResendCode.value = false
  setTimeout(() => {
    showResendCode.value = true
  }, 10 * 1000)
}
</script>
